import gql from 'graphql-tag';

export const EMAIL_BULK_CANDIDATES = gql`
  mutation emailBulkCandidates($shopifyToken: String!, $candidateIds: [String!], $emailForm: JSON) {
    emailBulkCandidates(input: { shopifyToken: $shopifyToken, candidateIds: $candidateIds, emailForm: $emailForm }) {
      status
      errors
    }
  }
`;

export const CREATE_SHOP_CAREER_PORTAL = gql`
  mutation createShopCareerPortal(
    $headingText: String
    $subheadingText: String
    $shopifyToken: String!
    $urlAndHandle: String
    $metaDescription: String
    $pageTitle: String!
    $introductionParagraph: Boolean
    $introductionHeading: String
    $introductionBody: String
    $jobListHeadingText: String
    $jobListCategoryFilterEnabled: Boolean
    $jobListLocationFilterEnabled: Boolean
    $jobListDepartmentFilterEnabled: Boolean
    $jobListKeywordFilterEnabled: Boolean
    $jobListSortEnabled: Boolean
    $deiStatment: Boolean
    $deiStatmentBody: String
    $employeeTestimonial: Boolean
    $employeeTestimonialTitle: String
    $postApplyHeading: String
    $postApplyBody: String
    $postApplyButton: String
    $postApplyButtonEnabled: Boolean
    $heroSection: StylesInput
    $paragraphSection: StylesInput
    $deiSection: StylesInput
    $testimonialSection: StylesInput
    $departmentsSection: Boolean
    $benefitsSection: Boolean
    $departmentTitle: String
    $departmentSection: StylesInput
    $jobListSection: StylesInput
    $jobDescriptionPage: StylesInput
    $postApplyPage: StylesInput
    $benefitsSectionStyles: StylesInput
    $buttonText: String
    $openRolesButton: Boolean
    $instagramUrl: String
    $instagramButtonEnabled: Boolean
    $facebookUrl: String
    $facebookButtonEnabled: Boolean
    $linkedinUrl: String
    $linkedinButtonEnabled: Boolean
    $twitterUrl: String
    $twitterButtonEnabled: Boolean
    $heroBackgroundImage: Upload
    $benefitsHeading: String
    $benefitsSubheading: String
    $sectionHero: Boolean
    $talentCommunityHeading: String
    $talentCommunityBody: String
    $talentCommunityForm: JSON
    $talentCommunityButton: String
    $talentCommunitySection: Boolean
    $talentCommunityStyles: StylesInput
  ) {
    createShopCareerPortal(
      input: {
        shopifyToken: $shopifyToken
        headingText: $headingText
        subheadingText: $subheadingText
        urlAndHandle: $urlAndHandle
        metaDescription: $metaDescription
        pageTitle: $pageTitle
        careerPortalInput: {
          introductionParagraph: $introductionParagraph
          introductionHeading: $introductionHeading
          introductionBody: $introductionBody
          deiStatment: $deiStatment
          buttonText: $buttonText
          postApplyHeading: $postApplyHeading
          postApplyBody: $postApplyBody
          postApplyButton: $postApplyButton
          postApplyButtonEnabled: $postApplyButtonEnabled
          jobListHeadingText: $jobListHeadingText
          jobListCategoryFilterEnabled: $jobListCategoryFilterEnabled
          jobListLocationFilterEnabled: $jobListLocationFilterEnabled
          jobListKeywordFilterEnabled: $jobListKeywordFilterEnabled
          jobListDepartmentFilterEnabled: $jobListDepartmentFilterEnabled
          jobListSortEnabled: $jobListSortEnabled
          openRolesButton: $openRolesButton
          deiStatmentBody: $deiStatmentBody
          employeeTestimonial: $employeeTestimonial
          employeeTestimonialTitle: $employeeTestimonialTitle
          departmentsSection: $departmentsSection
          benefitsSection: $benefitsSection
          departmentTitle: $departmentTitle
          instagramUrl: $instagramUrl
          instagramButtonEnabled: $instagramButtonEnabled
          facebookUrl: $facebookUrl
          facebookButtonEnabled: $facebookButtonEnabled
          linkedinUrl: $linkedinUrl
          linkedinButtonEnabled: $linkedinButtonEnabled
          twitterUrl: $twitterUrl
          twitterButtonEnabled: $twitterButtonEnabled
          benefitsHeading: $benefitsHeading
          benefitsSubheading: $benefitsSubheading
          heroBackgroundImage: $heroBackgroundImage
          sectionHero: $sectionHero
          talentCommunityHeading: $talentCommunityHeading
          talentCommunityBody: $talentCommunityBody
          talentCommunityForm: $talentCommunityForm
          talentCommunityButton: $talentCommunityButton
          talentCommunitySection: $talentCommunitySection
        }
        styleControlsInput: {
          heroSection: $heroSection
          paragraphSection: $paragraphSection
          deiSection: $deiSection
          testimonialSection: $testimonialSection
          departmentSection: $departmentSection
          jobListSection: $jobListSection
          jobDescriptionPage: $jobDescriptionPage
          postApplyPage: $postApplyPage
          benefitsSection: $benefitsSectionStyles
          talentCommunitySection: $talentCommunityStyles
        }
      }
    ) {
      shop {
        id
        careerPortal {
          id
          headingText
          subheadingText
          urlAndHandle
          metaDescription
          pageTitle
          introductionParagraph
          introductionHeading
          introductionBody
          deiStatment
          jobListHeadingText
          jobListCategoryFilterEnabled
          jobListLocationFilterEnabled
          jobListKeywordFilterEnabled
          jobListSortEnabled
          deiStatmentBody
          employeeTestimonial
          employeeTestimonialTitle
          departmentTitle
          heroBackgroundImage
          postApplyHeading
          postApplyBody
          postApplyButton
          postApplyButtonEnabled
          instagramUrl
          instagramButtonEnabled
          facebookUrl
          facebookButtonEnabled
          linkedinUrl
          linkedinButtonEnabled
          twitterUrl
          twitterButtonEnabled
          benefitsHeading
          benefitsSubheading
          styleControls
          sectionHero
          talentCommunityHeading
          talentCommunityBody
          talentCommunityButton
          talentCommunityForm
          talentCommunitySection
        }
        careerPortalSet
      }
      errors
    }
  }
`;
export const UPDATE_SHOP_CAREER_PORTAL = gql`
  mutation updateShopCareerPortal(
    $headingText: String
    $subheadingText: String
    $shopifyToken: String!
    $urlAndHandle: String
    $metaDescription: String
    $pageTitle: String
    $introductionParagraph: Boolean
    $introductionHeading: String
    $introductionBody: String
    $deiStatment: Boolean
    $deiStatmentBody: String
    $employeeTestimonial: Boolean
    $employeeTestimonialTitle: String
    $heroSection: StylesInput
    $paragraphSection: StylesInput
    $deiSection: StylesInput
    $testimonialSection: StylesInput
    $departmentsSection: Boolean
    $benefitsSection: Boolean
    $jobListHeadingText: String
    $jobListCategoryFilterEnabled: Boolean
    $jobListLocationFilterEnabled: Boolean
    $jobListKeywordFilterEnabled: Boolean
    $jobListDepartmentFilterEnabled: Boolean
    $jobListSortEnabled: Boolean
    $postApplyHeading: String
    $postApplyBody: String
    $postApplyButton: String
    $postApplyButtonEnabled: Boolean
    $sectionHero: Boolean
    $jobListSection: StylesInput
    $jobDescriptionPage: StylesInput
    $departmentSection: StylesInput
    $postApplyPage: StylesInput
    $benefitsSectionStyles: StylesInput
    $departmentTitle: String
    $buttonText: String
    $openRolesButton: Boolean
    $instagramUrl: String
    $instagramButtonEnabled: Boolean
    $facebookUrl: String
    $facebookButtonEnabled: Boolean
    $linkedinUrl: String
    $linkedinButtonEnabled: Boolean
    $twitterUrl: String
    $twitterButtonEnabled: Boolean
    $benefitsHeading: String
    $benefitsSubheading: String
    $talentCommunityHeading: String
    $talentCommunityBody: String
    $talentCommunityButton: String
    $talentCommunityForm: JSON
    $talentCommunitySection: Boolean
    $talentCommunityStyles: StylesInput
    $heroBackgroundImage: Upload
  ) {
    updateShopCareerPortal(
      input: {
        shopifyToken: $shopifyToken
        headingText: $headingText
        subheadingText: $subheadingText
        urlAndHandle: $urlAndHandle
        metaDescription: $metaDescription
        pageTitle: $pageTitle
        careerPortalInput: {
          introductionParagraph: $introductionParagraph
          introductionHeading: $introductionHeading
          introductionBody: $introductionBody
          deiStatment: $deiStatment
          deiStatmentBody: $deiStatmentBody
          employeeTestimonial: $employeeTestimonial
          employeeTestimonialTitle: $employeeTestimonialTitle
          departmentsSection: $departmentsSection
          benefitsSection: $benefitsSection
          departmentTitle: $departmentTitle
          buttonText: $buttonText
          postApplyHeading: $postApplyHeading
          postApplyBody: $postApplyBody
          postApplyButton: $postApplyButton
          postApplyButtonEnabled: $postApplyButtonEnabled
          instagramUrl: $instagramUrl
          instagramButtonEnabled: $instagramButtonEnabled
          facebookUrl: $facebookUrl
          facebookButtonEnabled: $facebookButtonEnabled
          linkedinUrl: $linkedinUrl
          linkedinButtonEnabled: $linkedinButtonEnabled
          twitterUrl: $twitterUrl
          twitterButtonEnabled: $twitterButtonEnabled
          jobListHeadingText: $jobListHeadingText
          jobListCategoryFilterEnabled: $jobListCategoryFilterEnabled
          jobListLocationFilterEnabled: $jobListLocationFilterEnabled
          jobListKeywordFilterEnabled: $jobListKeywordFilterEnabled
          jobListDepartmentFilterEnabled: $jobListDepartmentFilterEnabled
          jobListSortEnabled: $jobListSortEnabled
          openRolesButton: $openRolesButton
          benefitsHeading: $benefitsHeading
          benefitsSubheading: $benefitsSubheading
          heroBackgroundImage: $heroBackgroundImage
          sectionHero: $sectionHero
          talentCommunityHeading: $talentCommunityHeading
          talentCommunityBody: $talentCommunityBody
          talentCommunityButton: $talentCommunityButton
          talentCommunityForm: $talentCommunityForm
          talentCommunitySection: $talentCommunitySection
        }
        styleControlsInput: {
          heroSection: $heroSection
          paragraphSection: $paragraphSection
          deiSection: $deiSection
          testimonialSection: $testimonialSection
          departmentSection: $departmentSection
          jobListSection: $jobListSection
          jobDescriptionPage: $jobDescriptionPage
          postApplyPage: $postApplyPage
          benefitsSection: $benefitsSectionStyles
          talentCommunitySection: $talentCommunityStyles
        }
      }
    ) {
      shop {
        id
        careerPortal {
          id
          headingText
          subheadingText
          urlAndHandle
          metaDescription
          pageTitle
          introductionParagraph
          introductionHeading
          introductionBody
          deiStatment
          deiStatmentBody
          jobListHeadingText
          jobListCategoryFilterEnabled
          jobListLocationFilterEnabled
          jobListKeywordFilterEnabled
          jobListSortEnabled
          employeeTestimonial
          employeeTestimonialTitle
          departmentTitle
          styleControls
          departmentsSection
          benefitsSection
          postApplyHeading
          postApplyBody
          postApplyButton
          postApplyButtonEnabled
          instagramUrl
          instagramButtonEnabled
          facebookUrl
          facebookButtonEnabled
          linkedinUrl
          linkedinButtonEnabled
          twitterUrl
          twitterButtonEnabled
          benefitsHeading
          benefitsSubheading
          sectionHero
          talentCommunityHeading
          talentCommunityBody
          talentCommunityButton
          talentCommunityForm
          talentCommunitySection
        }
        careerPortalSet
      }
      errors
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation updateProfile(
    $companyName: String
    $phoneNumber: String
    $shopifyToken: String!
    $contactEmail: String
    $industry: String
    $employeeSize: String
    $careerPageLink: String
    $branding: Boolean
    $recaptchaEnabled: Boolean
    $weeklyApplicantSummary: Boolean
  ) {
    updateProfile(
      input: {
        shopifyToken: $shopifyToken
        profileInput: {
          companyName: $companyName
          phoneNumber: $phoneNumber
          contactEmail: $contactEmail
          industry: $industry
          employeeSize: $employeeSize
          careerPageLink: $careerPageLink
          branding: $branding
          weeklyApplicantSummary: $weeklyApplicantSummary
          recaptchaEnabled: $recaptchaEnabled
        }
      }
    ) {
      profile {
        contactEmail
        phoneNumber
        companyName
        industry
        employeeSize
        careerPageLink
        branding
        weeklyApplicantSummary
        recaptchaEnabled
      }
      errors
    }
  }
`;

export const UPDATE_ONBOARDING_PROFILE = gql`
  mutation updateOnboardingProfile($shopifyToken: String!, $onboardingInput: JSON!) {
    updateOnboardingProfile(input: { shopifyToken: $shopifyToken, onboardingInput: $onboardingInput }) {
      profile {
        id
      }
      errors
    }
  }
`;

export const UPDATE_EMAIL_TEMPLATE = gql`
  mutation updateEmailTemplate(
    $body: String!
    $emailTemplateId: String!
    $subject: String!
    $title: String!
    $shopifyToken: String!
    $sender: String
    $status: String
    $senderEmail: String
  ) {
    updateEmailTemplate(
      input: {
        shopifyToken: $shopifyToken
        emailTemplateId: $emailTemplateId
        body: $body
        subject: $subject
        title: $title
        sender: $sender
        status: $status
        senderEmail: $senderEmail
      }
    ) {
      emailTemplate {
        id
        subject
        variables
        title
        sender
        status
        senderEmail
      }
      errors
    }
  }
`;

export const CREATE_EMAIL_TEMPLATE = gql`
  mutation createEmailTemplate(
    $body: String!
    $title: String!
    $subject: String!
    $shopifyToken: String!
    $sender: String
    $status: String
    $senderEmail: String
  ) {
    createEmailTemplate(
      input: {
        shopifyToken: $shopifyToken
        body: $body
        title: $title
        status: $status
        subject: $subject
        sender: $sender
        senderEmail: $senderEmail
      }
    ) {
      emailTemplate {
        id
        subject
        variables
        title
        sender
        status
        senderEmail
      }
      errors
    }
  }
`;

export const UPDATE_LOCATION = gql`
  mutation updateLocation(
    $address1: String
    $address2: String
    $city: String
    $country: String
    $state: String
    $zipCode: String
    $locationId: String!
    $name: String
    $shopifyToken: String!
  ) {
    updateLocation(
      input: {
        shopifyToken: $shopifyToken
        locationId: $locationId
        locationInput: {
          address1: $address1
          address2: $address2
          zipCode: $zipCode
          state: $state
          city: $city
          country: $country
          name: $name
        }
      }
    ) {
      location {
        id
        address1
        address2
        country
        state
        zipCode
        city
        country
        name
      }
      errors
    }
  }
`;

export const UPDATE_GOOGLE_INTEGRATION = gql`
  mutation updateGoogleIntegration($shopifyToken: String!, $token: String!, $email: String!, $isActive: Boolean!) {
    updateGoogleIntegration(input: { shopifyToken: $shopifyToken, token: $token, email: $email, isActive: $isActive }) {
      googleIndexIntegration {
        email
        token
        isActive
      }
    }
  }
`;

export const REMOVE_SHOP_INTEGRATION = gql`
  mutation removeShopIntegration($shopifyToken: String!, $type: String!) {
    removeShopIntegration(input: { shopifyToken: $shopifyToken, type: $type }) {
      shop {
        id
        linkedinToken
        twitterToken
        airtableTokenExisting
        currentSubscription {
          id
          trialDays
          status
          appSubscriptionId
          currentPeriodEnd
          subscriptionType
          subscriptionPlan
          name
        }
      }
      errors
    }
  }
`;

export const ADD_LOCATION = gql`
  mutation addLocation(
    $address1: String
    $address2: String
    $city: String
    $country: String
    $state: String
    $zipCode: String
    $shopifyToken: String!
    $name: String
  ) {
    addLocation(
      input: {
        shopifyToken: $shopifyToken
        locationInput: {
          address1: $address1
          address2: $address2
          zipCode: $zipCode
          state: $state
          city: $city
          country: $country
          name: $name
        }
      }
    ) {
      location {
        id
        address1
        address2
        country
        state
        zipCode
        city
        country
        name
      }
      errors
    }
  }
`;

export const ADD_MEMBER = gql`
  mutation addTeamMember($firstName: String!, $lastName: String!, $email: String!, $shopifyToken: String!) {
    addTeamMember(
      input: { shopifyToken: $shopifyToken, memberInput: { firstName: $firstName, lastName: $lastName, email: $email } }
    ) {
      errors
    }
  }
`;

export const ADD_DISPOSITION_CODE = gql`
  mutation addDispositionCode($name: String!, $shopifyToken: String!) {
    addDispositionCode(input: { shopifyToken: $shopifyToken, codeInput: { name: $name } }) {
      errors
    }
  }
`;

export const UPDATE_MEMBER = gql`
  mutation updateTeamMember(
    $memberId: String!
    $firstName: String!
    $lastName: String!
    $email: String!
    $shopifyToken: String!
  ) {
    updateTeamMember(
      input: {
        shopifyToken: $shopifyToken
        memberId: $memberId
        memberInput: { firstName: $firstName, lastName: $lastName, email: $email }
      }
    ) {
      errors
    }
  }
`;

export const SEND_CANDIDATE_EMAIL = gql`
  mutation sendCandidateEmail(
    $message: String!
    $subject: String!
    $from: String!
    $to: String!
    $candidateId: String!
    $shopifyToken: String!
  ) {
    sendCandidateEmail(
      input: {
        shopifyToken: $shopifyToken
        message: $message
        subject: $subject
        from: $from
        to: $to
        candidateId: $candidateId
      }
    ) {
      errors
    }
  }
`;

export const SEND_TEST_EMAIL = gql`
  mutation sendTestEmail($message: String!, $subject: String!, $from: String!, $to: String!, $shopifyToken: String!) {
    sendTestEmail(input: { shopifyToken: $shopifyToken, message: $message, subject: $subject, from: $from, to: $to }) {
      errors
    }
  }
`;

export const UPDATE_DISPOSITION_CODE = gql`
  mutation updateDispositionCode($id: String!, $name: String!, $shopifyToken: String!) {
    updateDispositionCode(input: { shopifyToken: $shopifyToken, codeId: $id, codeInput: { name: $name } }) {
      errors
    }
  }
`;

export const REMOVE_MEMBER = gql`
  mutation deleteTeamMember($memberId: String!, $shopifyToken: String!) {
    deleteTeamMember(input: { memberId: $memberId, shopifyToken: $shopifyToken }) {
      status
      errors
    }
  }
`;

export const REFRESH_JOB = gql`
  mutation refreshJob($jobId: String!, $shopifyToken: String!) {
    refreshJob(input: { jobId: $jobId, shopifyToken: $shopifyToken }) {
      status
      errors
    }
  }
`;

export const REFRESH_JOB_KIT_SKILL = gql`
  mutation refreshJobKitSkill($jobId: String!, $shopifyToken: String!) {
    refreshJobKitSkill(input: { jobId: $jobId, shopifyToken: $shopifyToken }) {
      status
      errors
    }
  }
`;

export const REMOVE_DISPOSITION_CODE = gql`
  mutation deleteDispositionCode($codeId: String!, $shopifyToken: String!) {
    deleteDispositionCode(input: { codeId: $codeId, shopifyToken: $shopifyToken }) {
      status
      errors
    }
  }
`;

export const CREATE_SHOP_SUBSCRIPTION = gql`
  mutation createShopSubscription($shopifyToken: String!, $subscriptionType: String!) {
    createShopSubscription(input: { shopifyToken: $shopifyToken, subscriptionType: $subscriptionType }) {
      confirmationUrl
      errors
    }
  }
`;

export const CREATE_CANDIDATE_SCORE = gql`
  mutation createCandidateScore($shopifyToken: String!, $candidateId: String!, $thoughts: String!, $overallRating: String!) {
    createCandidateScore(
      input: { shopifyToken: $shopifyToken, candidateId: $candidateId, thoughts: $thoughts, overallRating: $overallRating }
    ) {
      candidate {
        id
        candidateScore {
          id
          thoughts
          overallRating
        }
      }
      errors
    }
  }
`;

export const CREATE_REFERENCE = gql`
  mutation createReference(
    $shopifyToken: String!
    $candidateId: String!
    $firstName: String!
    $lastName: String!
    $email: String!
    $phone: String!
    $company: String!
  ) {
    createReference(
      input: {
        shopifyToken: $shopifyToken
        candidateId: $candidateId
        firstName: $firstName
        lastName: $lastName
        email: $email
        phone: $phone
        company: $company
      }
    ) {
      errors
    }
  }
`;

export const CREATE_CANDIDATE_COMMENT = gql`
  mutation createCandidateComment(
    $shopifyToken: String!
    $candidateId: String!
    $content: String!
    $user: String!
    $mentions: [String!]
    $attachment: Upload
  ) {
    createCandidateComment(
      input: {
        shopifyToken: $shopifyToken
        candidateId: $candidateId
        content: $content
        user: $user
        mentions: $mentions
        attachment: $attachment
      }
    ) {
      comment {
        id
      }
      errors
    }
  }
`;

export const DELETE_CANDIDATE_COMMENT = gql`
  mutation deleteCandidateComment($shopifyToken: String!, $commentId: String!) {
    deleteCandidateComment(input: { shopifyToken: $shopifyToken, commentId: $commentId }) {
      errors
    }
  }
`;

export const UPDATE_CANDIDATE_SCORE = gql`
  mutation updateCandidateScore($shopifyToken: String!, $candidateId: String!, $thoughts: String!, $overallRating: String!) {
    updateCandidateScore(
      input: { shopifyToken: $shopifyToken, candidateId: $candidateId, thoughts: $thoughts, overallRating: $overallRating }
    ) {
      candidate {
        id
        candidateScore {
          id
          thoughts
          overallRating
        }
      }
      errors
    }
  }
`;

export const UPDATE_CANDIDATE_TAGS = gql`
  mutation updateCandidateTags($shopifyToken: String!, $candidateId: String!, $tags: [String!]!) {
    updateCandidateTags(input: { shopifyToken: $shopifyToken, candidateId: $candidateId, tags: $tags }) {
      candidate {
        id
        tags {
          id
          name
        }
      }
      errors
    }
  }
`;

export const CANCEL_SHOP_SUBSCRIPTION = gql`
  mutation cancelShopSubscription($shopifyToken: String!, $subscriptionId: ID!) {
    cancelShopSubscription(input: { shopifyToken: $shopifyToken, subscriptionId: $subscriptionId }) {
      subscription {
        id
      }
      errors
    }
  }
`;

export const CREATE_CANDIDATE = gql`
  mutation createCandidate(
    $name: String!
    $lastName: String!
    $email: String!
    $shopifyToken: String!
    $phone: String!
    $jobId: String!
    $resume: Upload!
  ) {
    createCandidate(
      input: {
        shopifyToken: $shopifyToken
        resume: $resume
        candidateInput: { name: $name, lastName: $lastName, email: $email, phone: $phone }
        jobId: $jobId
      }
    ) {
      candidate {
        id
        name
        email
        phone
      }
      errors
    }
  }
`;

export const DELETE_CANDIDATE = gql`
  mutation deleteCandidate(
    $shopifyToken: String!
    $candidateId: String!
  ) {
    deleteCandidate(
      input: {
        shopifyToken: $shopifyToken
        candidateId: $candidateId
      }
    ) {
      errors
    }
  }
`;

export const CREATE_JOB = gql`
  mutation createJob(
    $title: String!
    $description: String!
    $employmentType: String!
    $shopifyToken: String!
    $category: String!
    $department: String!
    $managerEmail: String
    $city: String
    $streetAddress: String
    $locationName: String
    $state: String
    $country: String
    $postalCode: String
    $status: String
    $isRemote: Boolean
    $compensationEnabled: Boolean
    $compensationType: String
    $maxCompensationRange: String
    $minCompensationRange: String
    $currency: String
    $plusComission: Boolean
    $isTemplate: Boolean
    $applicationFormFields: JSON
    $customQuestions: JSON
    $teamMemberIds: [String!]
    $questionnaireIds: [String!]
    $sendDisqualificationEmails: Boolean
  ) {
    createJob(
      input: {
        shopifyToken: $shopifyToken
        applicationFormFields: $applicationFormFields
        customQuestions: $customQuestions
        teamMemberIds: $teamMemberIds
        questionnaireIds: $questionnaireIds
        jobInput: {
          title: $title
          description: $description
          employmentType: $employmentType
          category: $category
          department: $department
          managerEmail: $managerEmail
          city: $city
          state: $state
          country: $country
          postalCode: $postalCode
          status: $status
          isRemote: $isRemote
          streetAddress: $streetAddress
          locationName: $locationName
          compensationEnabled: $compensationEnabled
          compensationType: $compensationType
          currency: $currency
          minCompensationRange: $minCompensationRange
          maxCompensationRange: $maxCompensationRange
          plusComission: $plusComission
          isTemplate: $isTemplate
        }
        jobSettingsInput: {
          sendDisqualificationEmails: $sendDisqualificationEmails
        }
      }
    ) {
      job {
        id
        title
        description
        employmentType
        category
        managerEmail
        country
        state
        city
        postalCode
        isRemote
        streetAddress
        currency
        compensationEnabled
        compensationType
        minCompensationRange
        maxCompensationRange
        plusComission
      }
      errors
    }
  }
`;

export const UPDATE_JOB = gql`
  mutation updateJob(
    $title: String!
    $description: String!
    $employmentType: String!
    $shopifyToken: String!
    $category: String!
    $department: String
    $managerEmail: String
    $city: String
    $archived: Boolean
    $streetAddress: String
    $locationName: String
    $state: String
    $country: String
    $postalCode: String
    $status: String
    $isRemote: Boolean
    $jobId: String!
    $compensationEnabled: Boolean
    $compensationType: String
    $maxCompensationRange: String
    $minCompensationRange: String
    $currency: String
    $plusComission: Boolean
    $applicationFormFields: JSON
    $customQuestions: JSON
    $teamMemberIds: [String!]
    $questionnaireIds: [String!]
    $sendDisqualificationEmails: Boolean
  ) {
    updateJob(
      input: {
        shopifyToken: $shopifyToken
        jobId: $jobId
        applicationFormFields: $applicationFormFields
        customQuestions: $customQuestions
        teamMemberIds: $teamMemberIds
        questionnaireIds: $questionnaireIds
        jobInput: {
          title: $title
          description: $description
          employmentType: $employmentType
          category: $category
          department: $department
          managerEmail: $managerEmail
          archived: $archived
          city: $city
          state: $state
          country: $country
          postalCode: $postalCode
          status: $status
          isRemote: $isRemote
          streetAddress: $streetAddress
          locationName: $locationName
          compensationEnabled: $compensationEnabled
          compensationType: $compensationType
          currency: $currency
          minCompensationRange: $minCompensationRange
          maxCompensationRange: $maxCompensationRange
          plusComission: $plusComission
        }
        jobSettingsInput: {
          sendDisqualificationEmails: $sendDisqualificationEmails
        }
      }
    ) {
      job {
        id
      }
      errors
    }
  }
`;
export const UPDATE_JOB_STATUS = gql`
  mutation updateJobStatus($jobId: String!, $shopifyToken: String!) {
    updateJobStatus(input: { jobId: $jobId, shopifyToken: $shopifyToken }) {
      status
      errors
    }
  }
`;

export const CREATE_JOB_TRANSLATION = gql`
  mutation createJobTranslation(
    $shopifyToken: String!
    $jobId: String!
    $translationInput: JobTranslationInput!
  ) {
    createJobTranslation(
      input: {
        shopifyToken: $shopifyToken
        jobId: $jobId
        translationInput: $translationInput
      }
    ) {
      jobTranslation {
        id
        locale
        title
        description
        isActive
        createdAt
        updatedAt
        localeName
      }
      errors
    }
  }
`;

export const UPDATE_JOB_TRANSLATION = gql`
  mutation updateJobTranslation(
    $shopifyToken: String!
    $translationId: String!
    $translationInput: JobTranslationInput!
  ) {
    updateJobTranslation(
      input: {
        shopifyToken: $shopifyToken
        translationId: $translationId
        translationInput: $translationInput
      }
    ) {
      jobTranslation {
        id
        locale
        title
        description
        isActive
        createdAt
        updatedAt
        localeName
      }
      errors
    }
  }
`;

export const DELETE_JOB_TRANSLATION = gql`
  mutation deleteJobTranslation($shopifyToken: String!, $translationId: String!) {
    deleteJobTranslation(
      input: {
        shopifyToken: $shopifyToken
        translationId: $translationId
      }
    ) {
      success
      errors
    }
  }
`;
export const REMOVE_SHOP_LOCATION = gql`
  mutation deleteShopLocation($locationId: String!, $shopifyToken: String!) {
    deleteShopLocation(input: { locationId: $locationId, shopifyToken: $shopifyToken }) {
      status
      errors
    }
  }
`;

export const REMOVE_SHOP_CUSTOM_WEBHOOK = gql`
  mutation deleteCustomWebhook($webhookId: String!, $shopifyToken: String!) {
    deleteCustomWebhook(input: { webhookId: $webhookId, shopifyToken: $shopifyToken }) {
      status
      errors
    }
  }
`;

export const UPDATE_CANDIDATE_STATUS = gql`
  mutation updateCandidateStatus($candidateId: String!, $shopifyToken: String!, $status: String!, $reasonId: String) {
    updateCandidateStatus(
      input: { candidateId: $candidateId, shopifyToken: $shopifyToken, status: $status, reasonId: $reasonId }
    ) {
      status
      errors
    }
  }
`;

export const UPDATE_CANDIDATE_ADDRESS = gql`
  mutation updateCandidateAddress(
    $candidateId: String!
    $shopifyToken: String!
    $address: String!
    $unit: String
    $city: String!
    $state: String!
    $zipcode: String!
  ) {
    updateCandidateAddress(
      input: {
        candidateId: $candidateId
        shopifyToken: $shopifyToken
        address: $address
        city: $city
        unit: $unit
        state: $state
        zipcode: $zipcode
      }
    ) {
      candidateAddress {
        id
      }
      errors
    }
  }
`;

export const UPLOAD_PROFILE_LOGO = gql`
  mutation uploadProfileLogo($shopifyToken: String!, $shopLogo: Upload) {
    uploadProfileLogo(input: { shopLogo: $shopLogo, shopifyToken: $shopifyToken }) {
      profile {
        id
        shopLogo
      }
    }
  }
`;

export const CREATE_CUSTOM_WEBHOOK = gql`
  mutation createCustomWebhook($shopifyToken: String!, $url: String!, $eventName: String!, $format: String!) {
    createCustomWebhook(input: { shopifyToken: $shopifyToken, url: $url, eventName: $eventName, format: $format }) {
      webhook {
        id
        url
        eventName
        format
      }
      errors
    }
  }
`;

export const CREATE_TESTIMONIAL = gql`
  mutation createTestimonial(
    $name: String!
    $quote: String!
    $shopifyToken: String!
    $testimonialPhoto: Upload!
    $role: String!
  ) {
    createTestimonial(
      input: { shopifyToken: $shopifyToken, name: $name, quote: $quote, role: $role, testimonialPhoto: $testimonialPhoto }
    ) {
      testimonial {
        id
        name
        role
        testimonialPhoto
        quote
      }
    }
  }
`;

export const UPDATE_TESTIMONIAL = gql`
  mutation updateTestimonial(
    $name: String!
    $quote: String!
    $shopifyToken: String!
    $testimonialPhoto: Upload
    $role: String!
    $testimonialId: String!
  ) {
    updateTestimonial(
      input: {
        shopifyToken: $shopifyToken
        name: $name
        quote: $quote
        role: $role
        testimonialPhoto: $testimonialPhoto
        testimonialId: $testimonialId
      }
    ) {
      testimonial {
        id
        name
        role
        testimonialPhoto
        quote
      }
      errors
    }
  }
`;

export const DELETE_TESTIMONIAL = gql`
  mutation deleteTestimonial($shopifyToken: String!, $testimonialId: String!) {
    deleteTestimonial(input: { shopifyToken: $shopifyToken, testimonialId: $testimonialId }) {
      status
      errors
    }
  }
`;

export const UPDATE_DEPARTMENT = gql`
  mutation updateDepartment(
    $headingText: String!
    $subheadingText: String
    $shopifyToken: String!
    $departmentId: String!
    $isHighlight: Boolean
  ) {
    updateDepartment(
      input: {
        shopifyToken: $shopifyToken
        headingText: $headingText
        subheadingText: $subheadingText
        departmentId: $departmentId
        isHighlight: $isHighlight
      }
    ) {
      department {
        id
        headingText
        subheadingText
        isHighlight
      }
    }
  }
`;

export const CREATE_DEPARTMENT = gql`
  mutation createDepartment($headingText: String!, $shopifyToken: String!) {
    createDepartment(input: { shopifyToken: $shopifyToken, headingText: $headingText }) {
      department {
        id
        headingText
        subheadingText
        isHighlight
      }
    }
  }
`;

export const DELETE_DEPARTMENT = gql`
  mutation deleteDepartment($shopifyToken: String!, $departmentId: String!) {
    deleteDepartment(input: { shopifyToken: $shopifyToken, departmentId: $departmentId }) {
      status
      errors
    }
  }
`;

export const UPDATE_BENEFIT = gql`
  mutation updateBenefit($headingText: String!, $iconKey: String!, $shopifyToken: String!, $benefitId: String!) {
    updateBenefit(input: { shopifyToken: $shopifyToken, headingText: $headingText, iconKey: $iconKey, benefitId: $benefitId }) {
      benefit {
        id
        headingText
        iconKey
      }
    }
  }
`;

export const CREATE_BENEFIT = gql`
  mutation createBenefit($headingText: String!, $iconKey: String!, $shopifyToken: String!) {
    createBenefit(input: { shopifyToken: $shopifyToken, headingText: $headingText, iconKey: $iconKey }) {
      benefit {
        id
        headingText
        iconKey
      }
    }
  }
`;

export const DELETE_BENEFIT = gql`
  mutation deleteBenefit($shopifyToken: String!, $benefitId: String!) {
    deleteBenefit(input: { shopifyToken: $shopifyToken, benefitId: $benefitId }) {
      status
      errors
    }
  }
`;

export const GEN_AIRTABLE_VERF_CODE = gql`
  mutation genAirtableVerfCode($shopifyToken: String!) {
    genAirtableVerfCode(input: { shopifyToken: $shopifyToken }) {
      code
      expiresIn
    }
  }
`;

export const SAVE_AIRTABLE_TOKEN = gql`
  mutation saveAirtableToken($shopifyToken: String!, $token: String!) {
    saveAirtableToken(input: { shopifyToken: $shopifyToken, token: $token }) {
      message
      status
    }
  }
`;

export const CREATE_SHOP_EVENT = gql`
  mutation createShopEvent($shopifyToken: String!, $event: String!) {
    createShopEvent(input: { shopifyToken: $shopifyToken, event: $event }) {
      errors
    }
  }
`;

export const UPDATE_QUESTIONNAIRE = gql`
  mutation updateQuestionnaire(
    $questionnaireId: String!
    $name: String!
    $shopifyToken: String!
    $status: String!
    $fields: JSON!
  ) {
    updateQuestionnaire(
      input: { questionnaireId: $questionnaireId, shopifyToken: $shopifyToken, status: $status, fields: $fields, name: $name }
    ) {
      questionnaire {
        id
      }
      errors
    }
  }
`;

export const CREATE_QUESTIONNAIRE = gql`
  mutation createQuestionnaire($name: String!, $shopifyToken: String!, $status: String!, $fields: JSON!) {
    createQuestionnaire(input: { shopifyToken: $shopifyToken, status: $status, fields: $fields, name: $name }) {
      questionnaire {
        id
      }
      errors
    }
  }
`;

export const ARCHIVE_JOB = gql`
  mutation archiveJob($jobId: String!, $shopifyToken: String!) {
    archiveJob(input: { jobId: $jobId, shopifyToken: $shopifyToken }) {
      status
      errors
    }
  }
`;

export const UNARCHIVE_JOB = gql`
  mutation unarchiveJob($jobId: String!, $shopifyToken: String!) {
    unarchiveJob(input: { jobId: $jobId, shopifyToken: $shopifyToken }) {
      status
      errors
    }
  }
`;
